<template>
  <div class="apply-header">
    <div class="app-breadcrumb">
      <a-breadcrumb :routes="currentRoute" separator=">">
        <template #itemRender="{ route }">
          {{ $t('user.' + route.title) }}
        </template>
      </a-breadcrumb>
      <div class="page-header">
        <div class="page-title">
          {{ $t('user.' + currentRoute[currentRoute.length - 1].title) }}
        </div>
        <div class="page-remark" v-if="showDate" >
          <template v-if="offline">
            {{ $t('user.This Session is Offline') }}
          </template>
          <template v-else>
            <calendar-outlined style="margin-right: 4px" />
            <span>
                {{ $t('user.Application Due Date') }}:{{ applicationPeriod[1] }}
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import { CalendarOutlined } from '@ant-design/icons-vue'
  import 'remixicon/fonts/remixicon.css'

  export default {
    name: 'ApplyHeader',
    components: { CalendarOutlined },
    props: {
      showDate: {
        default: true,
        type: Boolean,
      },
      offline: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        currentRoute: [],
      }
    },
    computed: {
      ...mapGetters({
        applicationPeriod: 'user/applicationPeriod',
        routes: 'routes/routes',
        menus: 'routes/menus',
        offlineMode: 'user/offlineMode',
      }),
    },
    watch: {
      $route: {
        handler({ path, matched }) {
          this.currentRoute = this.$route.matched
            .filter((item) => {
              return item.path != '/index' && item.path != '/home/index'
            })
            .map((item) => {
              return { title: item.meta.title, name: item.name }
            })
          // console.log(this.currentRoute)
        },
        immediate: true,
      },
    },
    methods: {},
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');

  .app-breadcrumb {
    background-color: white;
    padding: 12px 32px 12px 32px;
    font-size: 14px;
    color: #666666;
    .page-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 4px 0;
    }
    .page-remark {
      display: flex;
      align-items: center;
    }
    .page-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      font-weight: bold;
    }
  }
</style>
